// App.js
import React from 'react';
import SignupForm from '../../Components/Outseta/Signup';

const SignUpOutseta = () => {
    return (
        <div className='welcome-body signup-page left-0 !items-center !justify-around'>
            <SignupForm />
        </div>
    );
};

export default SignUpOutseta;